@if (loading) {
  <div class="fcwidget" role="status" aria-live="polite">
    <span class="fcwidget__spinner"></span>
    <span class="fcwidget__text">Opening Qbot AI Support…</span>
  </div>
}
